export default "__VITE_ASSET__CXB2QwTc__"